import {AppStore} from "../../desktop";
import {Invoice} from "../../models/Invoice";
import {InvoicesActionTypes} from "./types";
import {TabsActionTypes} from "../tabs";
import {InvoiceItem} from "../../models/InvoiceItem";
import {Customer} from "../../models/Customer";

export const actionInvoiceFetchAll = () => {
	AppStore.dispatch({type: InvoicesActionTypes.FETCH_ALL_REQUEST, payload: null})
}

export const actionInvoiceFetchAllCompleted = (invoices: Invoice[]) => {
	AppStore.dispatch({type: InvoicesActionTypes.FETCH_ALL_COMPLETED, payload: invoices})
}

export const actionInvoiceFetch = (invoice: Invoice) => {
	AppStore.dispatch({type: InvoicesActionTypes.FETCH_ONE_REQUEST, payload: invoice})
}

export const actionInvoiceFetchCompleted = (invoice: Invoice) => {
	AppStore.dispatch({type: InvoicesActionTypes.FETCH_ONE_COMPLETED, payload: invoice})
	AppStore.dispatch({type: TabsActionTypes.SET_TAB_ITEM, payload: invoice})
}

export const actionInvoiceSave = (invoice: Invoice) => {
	AppStore.dispatch({type: InvoicesActionTypes.SAVE_REQUEST, payload: invoice})
}

export const actionInvoiceSaveCompleted = (invoice: Invoice) => {
	AppStore.dispatch({type: InvoicesActionTypes.SAVE_COMPLETED, payload: invoice})
}

export const actionInvoiceDelete = (invoice: Invoice) => {
	AppStore.dispatch({type: InvoicesActionTypes.DELETE_REQUEST, payload: invoice})
}

export const actionInvoiceDeleteCompleted = (invoice: Invoice) => {
	AppStore.dispatch({type: InvoicesActionTypes.DELETE_COMPLETED, payload: invoice})
}

export const actionDeleteInvoices = (invoices: Invoice[]) => {
	AppStore.dispatch({type: InvoicesActionTypes.DELETE_MULTIPLE_REQUEST, payload: invoices})
}

export const actionDeleteInvoicesCompleted = (invoices: Invoice[]) => {
	AppStore.dispatch({type: InvoicesActionTypes.DELETE_MULTIPLE_COMPLETED, payload: invoices})
}

export const actionInvoiceItemSave = (invoiceItem: InvoiceItem, index: number) => {
	AppStore.dispatch({type: InvoicesActionTypes.INVOICEITEM_SAVE_REQUEST, payload: {invoiceItem: invoiceItem, index: index}})
}

export const actionInvoiceItemSaveCompleted = (invoiceItem: InvoiceItem, index: number) => {
	AppStore.dispatch({type: InvoicesActionTypes.INVOICEITEM_SAVE_COMPLETED, payload: {invoiceItem: invoiceItem, index: index}})
}

export const actionInvoiceItemDelete = (invoiceItem: InvoiceItem) => {
	AppStore.dispatch({type: InvoicesActionTypes.INVOICEITEM_DELETE_REQUEST, payload: invoiceItem})
}

export const actionInvoiceItemDeleteCompleted = () => {
	AppStore.dispatch({type: InvoicesActionTypes.INVOICEITEM_DELETE_COMPLETED, payload: null})
}

export const actionInvoiceFetchByCustomer = (customer: Customer) => {
	AppStore.dispatch({type: InvoicesActionTypes.FETCH_BY_CUSTOMER_REQUEST, payload: customer})
}

export const actionInvoiceFetchByCustomerCompleted = (invoices: Invoice[]) => {
	AppStore.dispatch({type: InvoicesActionTypes.FETCH_BY_CUSTOMER_COMPLETED, payload: invoices})
}
